import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

const bloomWordList = [
  "bloom",
  "blue",
  "bold",
  "bright",
  "brilliant",
  "burst",
  "circle",
  "collect",
  "cream",
  "cross",
  "dance",
  "deep",
  "fall",
  "flower",
  "gather",
  "golden",
  "honey",
  "intense",
  "nectar",
  "orange",
  "pollen",
  "purple",
  "rain",
  "red",
  "rich",
  "scent",
  "shower",
  "sugar",
  "sweet",
  "vibrant",
  "wing",
  "yellow",
];

export const bloomCollection: WordCollection = createCollection(
  "bloom",
  "Bloom & Buzz",
  bloomWordList,
  {
    icon: "flower",
    isWordlistViewable: true,
    startDate: new Date(new Date().getFullYear(), 3, 20), // April 20th
    endDate: new Date(new Date().getFullYear(), 4, 31), // May 31st
  },
);
